module.exports = __webpack_public_path__ + "344c48ba4e2a6d128559606ccac19aaa.ttf";